<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List AI Providers
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <a v-on:click="toggleModal('new_provider')" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Provider
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <ProviderTable />
                    </div>
                </div>
            </div>
            <modal name="new_provider" :height="'auto'" :width="'50%'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddProvider />
                </div>
            </modal>
            <modal name="edit_provider" :height="'auto'" :width="'50%'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <EditProvider :selectedProvider="selectedProvider" />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import ProviderTable from "@/components/tables/chat_gpt/ProviderTable.vue";
    import AddProvider from "@/components/forms/chat_gpt/provider/Add.vue";
    import EditProvider from "@/components/forms/chat_gpt/provider/Edit.vue";

    export default {
        components: {
            ProviderTable,
            AddProvider,
            EditProvider,
        },
        data() {
            return {
                selectedProvider: null
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
            this.$root.$off("edit_provider", this.fnEditProvider);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.fnEditProvider = (provider) => {
                this.selectedProvider = provider;
                this.toggleModal('edit_provider');
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
            this.$root.$on("edit_provider", this.fnEditProvider);
        },
        methods: {
            toggleModal(param) {
                this.$modal.toggle(param);
            },
        },
    };
</script>
